<template>
  <PartsLayoutContainer>
    <section class="sec_footer-contact">
      <OrganismsLayoutsContactBox />
    </section>
  </PartsLayoutContainer>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sec_footer-contact`（お電話でのお問い合わせ）。
 * サポート導線4コンテンツの1つ。単体では使わず `OrganismsSupport` から呼ぶ。
 * 中身はハンバーガーメニューと同じ `contact-box`（こちらは chrome 側に残す）。
 */
</script>
